"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDimensionsQuery = void 0;
function getDimensionsQuery(query, dateRange, filters, resultProcessor, timeDimension = 'Attribution.date') {
    const baseQuery = {
        timeDimensions: [
            {
                dimension: timeDimension,
                dateRange,
            },
        ],
        order: {},
        filters,
    };
    return {
        queries: [
            Object.assign(Object.assign({}, baseQuery), query),
        ],
        resultProcessor: resultProcessor ||
            ((rows) => {
                return rows[0]
                    .tablePivot()
                    .filter(obj => Object.values(obj)[0] && Object.values(obj)[1])
                    .map(obj => Object.values(obj)[0].toString());
            }),
    };
}
exports.getDimensionsQuery = getDimensionsQuery;
//# sourceMappingURL=helper.js.map